class ABTestVideoScroll extends HTMLElement {
  constructor() {
    super();
    this.hasTriggered = false;
    this.isMain = false;
    this.observer = null;
    this.muteButton = null;
  }

  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.isMain = this.hasAttribute('data-is-main');
    if (this.isMain) {
      const modalButton = this.querySelector('button.product__media-toggle');
      if (modalButton) {
        this.video.addEventListener('click', () => {
          modalButton.click();
        });
      }
      this.setupMuteButton();
      this.setupModalCloseListener();
    }
    this.video.muted = true;
    this.video.loop = true;
    this.video.playsInline = true;

    if (this.isMain) {
      this.setupMainVideoObserver();
    } else {
      this.setupThumbnailVideo();
    }
  }

  setupModalCloseListener() {
    // Listen for modal close to resume video playback
    const modal = document.querySelector('product-modal');
    if (modal) {
      const modalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'open') {
            const isModalOpen = modal.hasAttribute('open');
            if (!isModalOpen && this.classList.contains('swiper-slide-active')) {
              this.video.play().catch(() => {});
            }
          }
        });
      });
      modalObserver.observe(modal, { attributes: true });
    }
  }

  setupMuteButton() {
    this.muteButton = this.querySelector('.video-mute-button');
    if (!this.muteButton) return;

    this.muteButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleMute();
    });
  }

  updateMuteButtonIcon() {
    if (!this.muteButton) return;

    const isMuted = this.video.muted;
    const iconMuted = this.muteButton.querySelector('.icon-muted');
    const iconUnmuted = this.muteButton.querySelector('.icon-unmuted');

    this.muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');

    if (iconMuted) iconMuted.style.display = isMuted ? 'block' : 'none';
    if (iconUnmuted) iconUnmuted.style.display = isMuted ? 'none' : 'block';
  }

  toggleMute() {
    if (!this.video) return;
    this.video.muted = !this.video.muted;
    this.updateMuteButtonIcon();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupMainVideoObserver() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          this.handleMainActiveStateChange();
        }
      });
    });

    this.observer.observe(this, { attributes: true });
    this.handleMainActiveStateChange();
  }

  handleMainActiveStateChange() {
    const isActive = this.classList.contains('swiper-slide-active');
    
    if (isActive) {
      this.video.play().catch(() => {});
    } else {
      this.video.pause();
    }
  }

  setupThumbnailVideo() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          this.handleThumbnailActiveStateChange();
        }
      }); 
    });

    this.observer.observe(this, { attributes: true });

    this.triggerThumbnailPlay();
    this.setupThumbnailModalCloseListener();
  }

  setupThumbnailModalCloseListener() {
    const modal = document.querySelector('product-modal');
    if (modal) {
      const modalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'open') {
            const isModalOpen = modal.hasAttribute('open');
            const isActive = this.classList.contains('swiper-slide-thumb-active');
            if (!isModalOpen && !isActive && this.hasTriggered) {
              this.video.play().catch(() => {});
            }
          }
        });
      });
      modalObserver.observe(modal, { attributes: true });
    }
  }

  handleThumbnailActiveStateChange() {
    const isActive = this.classList.contains('swiper-slide-thumb-active');

    if (isActive) {
      this.video.pause();
    } else {
      if (this.hasTriggered) {
        this.video.play().catch(() => {});
      }
    }
  }

  triggerThumbnailPlay() {
    if (this.hasTriggered) return;
    this.hasTriggered = true;
    const isActive = this.classList.contains('swiper-slide-thumb-active');
    
    if (!isActive && this.video) {
      this.video.play().catch(() => {});
    }
  }
}

customElements.define('ab-test-video', ABTestVideoScroll);
